import type { RefObject } from 'react';
import { useCallback, useRef } from 'react';

import Icon from '@/components/common/Icon';
import * as SC from '@/components/common/RealTimeSearch.style';
import strings from '@/i18n';
import useThemeStore from '@/stores/themeStore';

type RealTimeSearchProps = {
  onDelete?: () => void;
  inputRef?: RefObject<HTMLInputElement>;
} & React.InputHTMLAttributes<HTMLInputElement>;

const RealTimeSearch = ({
  placeholder = strings.SEARCH__USER_PLACEHOLDER,
  onDelete,
  inputRef,
  ...args
}: RealTimeSearchProps) => {
  const { theme } = useThemeStore();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const deleteAndBlur = useCallback(() => {
    onDelete && onDelete();
    buttonRef?.current?.blur();
  }, [onDelete]);

  return (
    <SC.Container className='real-time-search-bar' mode={theme}>
      <SC.GroupBox>
        <Icon icon='IcSearch' size='20px' color={'#CCCCCC'} />
        <SC.SearchInput ref={inputRef} type='text' isDark={theme === 'dark'} placeholder={placeholder} {...args} />
      </SC.GroupBox>
      {args.value && String(args.value)?.length > 0 && (
        <SC.IconButtonBox ref={buttonRef} onClick={deleteAndBlur}>
          <Icon icon='IcDelete' size='20px' />
        </SC.IconButtonBox>
      )}
    </SC.Container>
  );
};

export default RealTimeSearch;
